import { render } from "./PractitionersTableHeader.vue?vue&type=template&id=2ebb811a"
import script from "./PractitionersTableHeader.vue?vue&type=script&lang=js"
export * from "./PractitionersTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__